import React from 'react';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import LoaderData from "./LoaderData/LoaderData";
import Auth from './../Auth';

export const PrivateRouteApp = () => {
  let { token, lang, id } = useParams();
  const location = useLocation();

  // Open the tab session if not authenticated (shared password session first, else the page link)
  if (!Auth.isAuthenticated()) {
    let t = location.pathname.split('/');
    let codePage = null;
    for(let i = 0; i < t.length; i++) {
      if(t[i] !== '' && t[i].indexOf(':') === -1) {
        codePage = t[i];
      }
    }
    if (codePage === 'preCheckIn') {
      codePage = 'checkin'
    }
    else if (codePage === 'bookingFolderInformations') {
      codePage = 'bookings'
    }

    Auth.openTabSession(lang, codePage, id);
  }

  return Auth.isAuthenticated()
      ? <LoaderData/>
      : <Navigate to={`/${token}/${lang}/login`} state={{from: location}}/>;
}

export const PrivateRouteBookingFolderInformations = () => {
  const { token, lang, id } = useParams();
  const location = useLocation();

  // Link session of this tab only
  let codePage = location.pathname.split('/').find(p => p === 'bookingFolderInformations') ? 'bookings' : null;
  Auth.openLinkSession(lang, codePage, id);

  // Check if user is authenticated
  if (!Auth.isAuthenticated()) {
    return <Navigate to={`/${token}/${lang}/login`} state={{ from: location }} />;
  }

  // If authenticated render LoaderData
  return <LoaderData />;
};
